import breakpoints from 'scss-settings/_settings.grid.scss';
import CustomElement from '~utilities/custom-element';

const IS_ACTIVE = 'is--active';
const OPTIONS = 'options';

class Devbar extends CustomElement {
    constructor() {
        super();
    }

    template() {
        return `
            <div class="d-devbar" js-devbar="${this.getAttribute(OPTIONS) ? this.getAttribute(OPTIONS) : ''}">
                <div class="d-grid-view">
                    <div class="grid-view__container" js-grid-container>
                        <div class="row grid-view__row">
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                            <div class="col-1 grid-view__col"></div>
                        </div>
                    </div>
                </div>
                <div class="d-bar">
                    <div class="container">
                        <div class="row bar__row">
                            <div class="col-md-4">
                                <b>Screen Size:</b>
                                <span js-devbar-size></span>
                            </div>
                            <div class="col-md-4">
                                <b>Breakpoint:</b> 
                                <span js-devbar-media></span>
                            </div>
                            <div class="col-md-4">
                                <button class="bar__button" js-devbar-toggle-grid>Toggle Grid</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    callback() {
        super.callback();

        this.toggleGridButton = this.element.querySelector('[js-devbar-toggle-grid]');
        this.screenSize = this.element.querySelector('[js-devbar-size]');
        this.mediaQuery = this.element.querySelector('[js-devbar-media]');
        this.gridContainer = document.querySelector('[js-grid-container]');
        this.options();
        this.getScreenSize();
        this.bindEvents();
    }

    options() {
        let options = this.element.getAttribute('js-devbar');
        if(options) {
            options = options.split('|');

            options.forEach(option => {
                switch(option) {
                    case 'fluid':
                        this.gridContainer.classList.add('container-fluid');
                        break;
                    default:
                        this.gridContainer.classList.add('container');
                        break;
                }
            });
        } else {
            this.gridContainer.classList.add('container');
        }
    }

    bindEvents() {

        this.toggleGridButton.addEventListener('click', () => this.toggleGrid());
        window.addEventListener('resize', () => this.getScreenSize());
    }

    toggleGrid() {
        const grid = document.querySelector('.d-grid-view');

        grid.classList.contains(IS_ACTIVE) ? grid.classList.remove(IS_ACTIVE) : grid.classList.add(IS_ACTIVE);
    }

    getScreenSize() {
        const {innerWidth, innerHeight} = window;
        this.screenSize.innerHTML = `${innerWidth}x${innerHeight}`;

        this.getMediaQuery(innerWidth);
    }

    getMediaQuery(innerWidth) {
        this.mediaQuery.innerHTML = this.findBreakpoint(innerWidth);
    }

    findBreakpoint(innerWidth) {
        let visibleBreakpoint = 'xs';
        Object.keys(breakpoints).forEach(function(key) {
            if(breakpoints[key] <= innerWidth) visibleBreakpoint = key;
        });
        return visibleBreakpoint;
    }
}

export default Devbar;
